import { AccountsTable } from "@/components/accounts/AccountsTable";

export function AccountsPage() {
  return <AccountsTable />;
}
